import React from 'react';
import ResetPasswordRequestForm from './ResetPasswordRequestForm';
import { ToastProvider } from '../../providers/ToastProvider';

export default {
  title: 'Components/PasswordReset/ResetPasswordRequestForm',
  component: ResetPasswordRequestForm,
  tags: ['autodocs'],
  parameters: {
    layout: 'centered',
  },
  decorators: [
    (Story) => (
      <ToastProvider>
        <div className="p-8 bg-gray-50 min-h-100">
          <Story />
        </div>
      </ToastProvider>
    ),
  ],
};

export const Default = () => <ResetPasswordRequestForm />;
